import { getCurrentRouteName, getCurrentRouteParams } from '@neptune/shared/routing-business-logic';

import { LastNotificationTimestampState } from './last-notification-timestamp-reducer';

export const getLastNotificationTimestampState = (state: any): LastNotificationTimestampState => {
  return state.leaderboardsLastNotificationTimestamp;
};

export function getLastNotificationTimestamp(
  state: any,
  leaderboardId: string,
): number | undefined {
  return getLastNotificationTimestampState(state)[leaderboardId];
}

export function getLastNotificationTimestampForRuns(
  state: any,
  leaderboardId: string,
): number | undefined {
  const path = getCurrentRouteName(state);
  const currentRouteParams = getCurrentRouteParams(state);

  /**
   * ExperimentLeaderboardCompareContextProvider is mounted for both details and runs tabs.
   * When we are on details tab, we don't want to fetch last notification timestamp
   * because it will be fetched by mechanism defined in EntityDetailsContainer.
   */
  if (path === 'project.runs-tab' && currentRouteParams?.tab === 'details') {
    return undefined;
  }

  return getLastNotificationTimestampState(state)[leaderboardId];
}
